export default {
  path: 'account',
  name: 'SicuraSolutionAccount',
  component: () => import('@/views/private/MyUser.vue'),
  children: [
    {
      path: 'preferenze-notifiche',
      name: 'SicuraSolutionNotificationPreferences',
      component: () => import('@/components/my-user/NotificationsPreferences.vue'),
    },
    {
      path: 'anagrafica',
      name: 'SicuraSolutionAnagrafica',
      component: () => import('@/components/my-user/Anagrafica.vue'),
    },
    {
      path: 'password',
      name: 'SicuraSolutionUpdatePassword',
      component: () => import('@/components/my-user/UpdatePassword.vue'),
    },
  ],
};
